<div class="calendar">
    <full-calendar #fullCalendar [options]="calendarOptions" class="{{ !isClickedRow ? 'cursor_none' : 'cursor_pointer'}}"></full-calendar>
</div>
